import { gql } from '@apollo/client';
import { useAxiosQuery, useLazyAxios } from '@isyc-react/oc-api';
import axios from 'axios';
import { useBuVariables } from 'common/utils/bu-variables-hook';
export const BAILLEURS_FOOTER = gql `
  query footerArchive($footerType: FooterType, $businessUnitId: Long, $businessUnitCode: String) {
    footerArchive(businessUnitId: $businessUnitId, businessUnitCode: $businessUnitCode, footerType: $footerType) {
      format
      name
      content
    }
  }
`;
export var FooterType;
(function (FooterType) {
    FooterType["CONFIDENTIAL"] = "CONFIDENTIAL";
    FooterType["HELP"] = "HELP";
    FooterType["LEGAL_MENTIONS"] = "LEGAL_MENTIONS";
})(FooterType || (FooterType = {}));
export const useBailleursConfigurationFooterLazyQuery = (options) => {
    var _a, _b, _c;
    const buVariables = useBuVariables();
    return useLazyAxios({
        url: `/api/public/bailleurs/footerArchive?footerType=${(_a = options === null || options === void 0 ? void 0 : options.variables) === null || _a === void 0 ? void 0 : _a.footerType}&businessUnitId=${(_b = buVariables.businessUnitId) !== null && _b !== void 0 ? _b : ''}&businessUnitCode=${(_c = buVariables.businessUnitCode) !== null && _c !== void 0 ? _c : ''}`,
        method: 'GET'
    });
};
export const useBailleursConfigurationFooterQuery = (options) => {
    var _a, _b, _c, _d;
    const buVariables = useBuVariables();
    return useAxiosQuery(`/api/public/bailleurs/footerArchive?footerType=${(_b = (_a = options === null || options === void 0 ? void 0 : options.variables) === null || _a === void 0 ? void 0 : _a.footerType) !== null && _b !== void 0 ? _b : ''}&businessUnitId=${(_c = buVariables.businessUnitId) !== null && _c !== void 0 ? _c : ''}&businessUnitCode=${(_d = buVariables.businessUnitCode) !== null && _d !== void 0 ? _d : ''}`);
};
export const useBailleursConfigurationFooterPromiseQuery = (options) => {
    const buVariables = useBuVariables();
    return () => new Promise((resolve, reject) => {
        var _a, _b, _c, _d;
        return axios.get(`/api/public/bailleurs/footerArchive?footerType=${(_b = (_a = options === null || options === void 0 ? void 0 : options.variables) === null || _a === void 0 ? void 0 : _a.footerType) !== null && _b !== void 0 ? _b : ''}&businessUnitId=${(_c = buVariables.businessUnitId) !== null && _c !== void 0 ? _c : ''}&businessUnitCode=${(_d = buVariables.businessUnitCode) !== null && _d !== void 0 ? _d : ''}`)
            .then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
};
